/*
 * Analyze User Agent
 */




// export default function() {
module.exports.analyze = () => {
  let userAgent = window.navigator.userAgent.toLowerCase();
  let userDevice;

  if (
      userAgent.indexOf('iphone') != -1
      || userAgent.indexOf('ipad') != -1
      || userAgent.indexOf('android') != -1 ) {
    userDevice = 'mobile';
  } else {
    userDevice = 'laptop';
  }
  return userDevice;
};

